<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="historical-landmarks-of-the-time">
<h1>Historical Landmarks of <br/>the Time</h1>
<p>1961 – Ayuttaya World Heritage site</p><br/>
<p style="text-indent:0em">1961 – fighting in Burma</p><br/>
<p style="text-indent:0em">1962–63 – Three Seals Code</p><br/>
<p style="text-indent:0em">1972 – UN Conference on Human Environment</p><br/>
<p style="text-indent:0em">1972–73 EU Environmental Action Plan</p><br/>
<p style="text-indent:0em">1975 – Ratchaphatsadu Land Act &amp; City Planning Act</p><br/>
<p style="text-indent:0em">1977 – Charnivit Kasetsri’ book ‘The Rise of Ayuttaya’</p><br/>
<p style="text-indent:0em">1978 – Three Seals Law revised</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?7f8037a8